import React from 'react';
import {Grid} from "@material-ui/core";
import styled from "styled-components";
import {StyledTextarea} from "../../form/textarea";
import {StyledInput} from "../../form/input";
import {BoxWrapper} from "../../box-wrapper/box-wrapper";
import {StyledCheckbox} from "../../form/checkbox";
import {useTranslation} from "react-i18next";
import {StyledRadioButton} from "../../form/radio";

export const AddBookFormStep2 = ({form}) => {
    const { t } = useTranslation(['author', 'common']);

    return (
        <Grid
            container
            direction="row"
        >

            <StyledMainGrid container item sm={12} md={7} direction={'column'} spacing={2}>
                <BoxWrapper title={t('addBook.characteristic') + ':'}>
                    <Grid container item direction={'column'} spacing={2}>
                        <Grid container item direction={'column'}>
                            <StyledTextarea
                                id="partOfManuscript"
                                label={t('addBook.form.partOfManuscript')}
                                onChange={form.handleChange}
                                value={form.values.partOfManuscript}
                                rows={12}
                            />
                        </Grid>

                        <Grid container item direction={'column'}>
                            <StyledTextarea
                                id="description"
                                label={t('addBook.form.description')}
                                onChange={form.handleChange}
                                value={form.values.description}
                                rows={12}
                            />
                        </Grid>

                        <Grid container item direction={'column'}>
                            <StyledTextarea
                                id="summary"
                                label={t('addBook.form.summary')}
                                onChange={form.handleChange}
                                value={form.values.summary}
                                rows={12}
                            />
                        </Grid>
                    </Grid>
                </BoxWrapper>
            </StyledMainGrid>

            <StyledMainGrid container item sm={12} md={5} direction={'column'} spacing={3}>
                <Grid container item direction={'column'}>
                    <StyledCheckbox
                        id={"availableForMarket"}
                        name={"availableForMarket"}
                        onChange={form.handleChange}
                        value={form.values.availableForMarket}
                        label={t('addBook.form.availableForMarket')}
                    />
                </Grid>

                <Grid container item direction={'column'}>
                    <StyledRadioButton
                        label={t('addBook.form.typeOfNarration')}
                        options={[{label: t('addBook.form.typeOfNarration1'), value: '1'}, {label: t('addBook.form.typeOfNarration2'), value: '2'}, {label: t('addBook.form.typeOfNarration3'), value: '3'}]}
                        onChange={(event) => {
                            form.setFieldValue('typeOfNarration', event.target.value);
                        }}
                        value={form.values.typeOfNarration}
                    />
                </Grid>
                <Grid container item direction={'column'}>
                    <StyledInput
                        id="realLocation"
                        label={t('addBook.form.realLocation')}
                        onChange={form.handleChange}
                        value={form.values.realLocation}
                    />
                </Grid>
                <Grid container item direction={'column'}>
                    <StyledInput
                        id="fictionLocation"
                        label={t('addBook.form.fictionLocation')}
                        onChange={form.handleChange}
                        value={form.values.fictionLocation}
                    />
                </Grid>
                <Grid container item direction={'column'}>
                    <StyledInput
                        id="actionTime"
                        label={t('addBook.form.actionTime')}
                        onChange={form.handleChange}
                        value={form.values.actionTime}
                    />
                </Grid>

                <BoxWrapper title={t('addBook.form.perfectReader') + ':'} style={{marginTop: '30px'}}>
                    <Grid container item direction={'column'} spacing={3}>
                        <Grid container item direction={'column'}>
                            <StyledInput
                                id="readerAge"
                                label={t('addBook.form.age')}
                                onChange={form.handleChange}
                                value={form.values.readerAge}
                            />
                        </Grid>
                        <Grid container item direction={'column'}>
                            <StyledInput
                                id="readerGender"
                                label={t('addBook.form.sex')}
                                onChange={form.handleChange}
                                value={form.values.readerGender}
                            />
                        </Grid>
                        {/*<Grid container item direction={'column'}>*/}
                        {/*    <StyledInput*/}
                        {/*        id="readerType"*/}
                        {/*        label="Zainteresowania"*/}
                        {/*        onChange={form.handleChange}*/}
                        {/*        value={form.values.readerType}*/}
                        {/*    />*/}
                        {/*</Grid>*/}
                        <Grid container item direction={'column'}>
                            <StyledInput
                                id="readerAddInfo"
                                label={t('addBook.form.addInfo')}
                                onChange={form.handleChange}
                                value={form.values.readerAddInfo}
                            />
                        </Grid>
                    </Grid>
                </BoxWrapper>
            </StyledMainGrid>
        </Grid>
    );
}

const StyledMainGrid = styled(Grid)`
    padding: 2rem 2rem;
`;
